<!-- Use preprocessors via the lang attribute! e.g. <template lang="pug"> -->
<template>
  <div class="custom-main">
    <div class="d-flex flex-column justify-space-between mx-4 my-4">
      <v-row align="center" justify="center">
        <v-col cols="12" md="6" class="px-2">
          <p class="text-h6">
            Most Valuable Partner {{ new Date().getFullYear() }}
          </p>
          <div v-if="!getFeedback.dovote">
            <v-select
              background-color="indigo lighten-5"
              outlined
              :items="employees"
              item-text="fullname"
              item-value="id"
              label="pilih karyawan"
              class="pb-1 demo-select"
              hide-details="auto"
              v-model="selection"
              color="indigo lighten-2"
            >
            </v-select>

            <v-btn
              color="indigo lighten-2"
              @click="kirimEmplPerformance"
              block
              class="py-6 mt-0 white--text mb-5"
            >
              Send
            </v-btn>
          </div>

          <div v-else>
            <v-alert dense text type="success" class="body-2"
              >Terima kasih, anda sudah berpartisipasi dalam pemilihan MVP
              Employee tahun ini</v-alert
            >
            <!-- <div v-if="topEmp.length">
              <v-row
                class="rounded-lg mx-0"
                style="
                  background: white;
                  margin-top: 0.3em;
                  margin-bottom: 0.3em;
                "
                v-for="(emp, y) in topEmp"
                :key="y"
              >
                <v-col
                  cols="2"
                  align="center"
                  justify="center"
                  class="ma-0 px-0"
                >
                  <v-img
                    height="40"
                    width="40"
                    src="https://upload.wikimedia.org/wikipedia/id/thumb/c/cc/Chelsea_FC.svg/1200px-Chelsea_FC.svg.png"
                    class="rounded-circle"
                  ></v-img>
                </v-col>
                <v-col xs="10" align="left" justify="center" class="pl-1">
                  <div class="font-weight-bold pb-0 body-2 ma-0 pa-0">
                    {{ emp.initial }}
                  </div>
                  <div
                    class="grey--text pa-0 ma-0 caption"
                    @click="kirimEmplPerformance"
                  >
                    {{ emp.dept }} - Point {{ emp.point }}
                  </div>
                </v-col>
              </v-row>
            </div> -->
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="text-center" v-if="loading">
      <v-overlay>
        <v-progress-circular
          :size="70"
          :width="10"
          color="amber"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </div>

    <Snackbar
      :active="activeSnackbar"
      :text="pesan"
      @hideSnackbar="hideSnackbar"
    />
  </div>
</template>

<script>
import Snackbar from "../../components/Snackbar.vue";

export default {
  components: {
    Snackbar,
  },
  data: () => ({
    activeStatus: true,
    loading: false,
    selection: "",
    panels: [0, 1],
    employees: [],
    topEmp: [
      {
        initial: "John Doe",
        dept: "ISI",
        point: "9",
      },
      {
        initial: "James Bond",
        dept: "HRK",
        point: "11",
      },
      {
        initial: "Bruce",
        dept: "NTX",
        point: "10",
      },
      {
        initial: "Bryan",
        dept: "Support",
        point: "8",
      },
    ],
    //snackbar
    activeSnackbar: false,
    pesan: "Pastikan anda mengisi dengan benar",
  }),
  computed: {
    getInfo() {
      return this.$store.getters.userInfo;
    },
    getFeedback() {
      return this.$store.getters.userFeedback;
    },
  },

  beforeMount() {
    this.fetchData();
    this.fetchStatus();
  },

  methods: {
    fetchData() {
      this.axios
        // .post(`${process.env.VUE_APP_API}/api/users/company`, {
        //   company: this.getInfo.company
        // })
        .get(
          `${process.env.VUE_APP_API}/api/users/company?company=` +
            this.getInfo.company
        )
        .then((response) => {
          const payload = response.data;
          for (let i = 0; i < payload.data.length; i++) {
            if (payload.data[i].digits != this.getInfo.digits) {
              // console.log(payload.data[i]);
              this.employees.push({
                id: payload.data[i].digits,
                digits: payload.data[i].digits,
                company: payload.data[i].company,
                fullname: payload.data[i].fullname,
              });
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            const payload = error.response.data;
            // const obj = JSON.parse(payload)
            this.pesan = payload.message;
            this.alert = true;
          } else {
            const payload = error.message;
            // const obj = JSON.parse(payload)
            this.pesan = payload;
            this.alert = true;
          }
          // console.log(payload.message);
        });
    },
    kirimEmplPerformance() {
      if (this.selection) {
        this.loading = true;

        this.axios
          .post(`${process.env.VUE_APP_API}/api/votes/post`, {
            votedDigits: this.selection,
            digits: this.$store.getters.userInfo.digits,
            // id: this.$store.getters.userInfo.userId,
            // eventTitle: "",
            // eventMeetingLink: "",
          })
          .then((response) => {
            const payload = response.data;
            // console.log(payload.data);
            this.buttonDisabled2 = false;
            this.fetchStatus();
          });

        setTimeout(() => {
          this.loading = false;
          // console.log(this.selection);
          this.activeStatus = !this.activeStatus;
        }, 2000);
        this.activeSnackbar = false;
      } else {
        this.activeSnackbar = true;
      }
    },

    fetchStatus() {
      this.axios
        .get(
          `${process.env.VUE_APP_API}/api/users/status/` + this.getInfo.digits
        )
        .then((response) => {
          const payload = response.data.data;
          this.buttonDisabled1 = payload.dosurvey;
          this.$store.commit("SET_STATUS_FB", payload);
        })
        .catch((error) => {
          if (error.response) {
            const payload = error.response.data;
            // const obj = JSON.parse(payload)
            this.pesan = payload.message;
            this.alert = true;
          } else {
            const payload = error.message;
            // const obj = JSON.parse(payload)
            this.pesan = payload;
            this.alert = true;
          }
          // console.log(payload.message);
        });
    },
    //snackbar
    hideSnackbar() {
      this.activeSnackbar = false;
    },
  },
};
</script>
<style scoped>
.theme--light.v-list {
  text-align: left;
  margin-bottom: 0px;
  padding-bottom: 0px;
  font-weight: bold;
}
</style>
